export default function (value) {
  if (value === 'GARANTIE') return 'Garantie'
  if (value === 'KAUFSCHUTZ') return 'Kaufschutz'
  return value
}
